import React from "react";

export default function Center({
  width,
  children,
  className,
}: {
  width: number | undefined;
  children?: any;
  className?: string;
}) {
  return (
    <div
      style={{ maxWidth: `${width ? width + "px" : "100%"}`, margin: `0 auto` }}
      className={className}
    >
      {children}
    </div>
  );
}
